import * as z from "zod";

export const getVoidReplacementLots = {
  name: "getVoidReplacementLots" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({
    voidedFromOgFulfillmentGroupId: z.string().nullable(),
    lots: z.array(
      z.object({
        lineItemExternalId: z.string(),
        lotNumber: z.string(),
        expirationDate: z.date().nullable(),
        quantity: z.number(),
      }),
    ),
  }),
};

export type GetVoidReplacementLotsInput = z.infer<
  typeof getVoidReplacementLots.input
>;
export type GetVoidReplacementLotsOutput = z.infer<
  typeof getVoidReplacementLots.output
>;
